import { Component, input, output } from '@angular/core';

@Component({
  selector: 'rid-selection-handle',
  imports: [],
  templateUrl: './rid-selection-handle.html',
  host: {
    class: 'absolute -top-8 -translate-x-1/2 cursor-grab touch-none',
    '[style.left.px]': 'left()',
    '(pointerdown)': 'onPointerDown($event)',
    '(pointermove)': 'onPointerMove($event)',
    '(pointerup)': 'onPointerUp($event)',
  },
})
export class RidSelectionHandle {
  left = input.required<number>();

  dragStart = output<PointerEvent>();
  dragMove = output<PointerEvent>();
  dragEnd = output<PointerEvent>();

  private dragging = false;

  onPointerDown(event: PointerEvent) {
    event.stopPropagation();
    (event.currentTarget as HTMLElement).setPointerCapture(event.pointerId);
    this.dragging = true;
    this.dragStart.emit(event);
  }

  onPointerMove(event: PointerEvent) {
    if (!this.dragging) return;

    this.dragMove.emit(event);
  }

  onPointerUp(event: PointerEvent) {
    if (!this.dragging) return;

    (event.currentTarget as HTMLElement).releasePointerCapture(event.pointerId);
    this.dragging = false;
    this.dragEnd.emit(event);
  }
}
